import { SIDE_NAV } from './constants';

export const toggleSideNav = () => ({
  type: SIDE_NAV.TOGGLE,
});

export const closeSideNav = () => ({ type: SIDE_NAV.CLOSE });
